// extracted by mini-css-extract-plugin
export default {"two-row-layout":"twoRow_two-row-layout__TBl2l"};